import Six from './Six'
import Five from './Five'
import Four from './Four'
import Year from './Year'

type TProps = {
  Seven: typeof Six
  Five: typeof Five
  Four: typeof Four
  Year: typeof Year
}
const StarPanel: TProps = {} as TProps

StarPanel.Seven = Six
StarPanel.Five = Five
StarPanel.Four = Four
StarPanel.Year = Year
export default StarPanel
